import { usePacketInput } from '../Contexts/PacketInputContext';
import { Mixpanel } from '../../../services/Mixpanel';

export const ReadingGenerationModeSelector = () => {
  const { preserveOriginalText, setPreserveOriginalText, inputType } = usePacketInput();

  return (
    <div
      onClick={() => {
        Mixpanel.track('Preserve Original Text checkbox clicked', {
          to: !preserveOriginalText,
          tab: inputType.id,
        });
        setPreserveOriginalText(!preserveOriginalText);
      }}
      className='cursor-pointer px-3 py-2 gap-x-2 text-gray-900 w-fit bg-gray-50 hover:bg-gray-100 rounded-lg outline outline-1 outline-offset-[-1px] outline-gray-100 inline-flex justify-start items-center gap-1'>
      <input
        type='checkbox'
        checked={preserveOriginalText}
        onChange={(e) => setPreserveOriginalText(e.target.checked)}
        className='rounded cursor-pointer border-gray-300 text-emerald-600 focus:ring-0 focus-visible:ring-1 focus-visible:ring-emerald-500 h-4 w-4'
      />

      <div className='text-xs sm:text-sm'>Preserve Original Text</div>
    </div>
  );
};
